module.exports = __webpack_public_path__ + "static/img/ser-b-3.7081e2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/setmeal/ser-b-3.png
// module id = TljB
// module chunks = 1